/*
 * 運用結果の計算ロジック（純粋関数）
 */
import BigNumber from 'bignumber.js';

export default class InterestRateCalculator {
  // 定数: 1年の日数
  static DAYS_PER_YEAR = 365;

  // 定数: 投資金額ベース計算で使用する基準投資金額（円）
  static DEFAULT_INVESTMENT_AMOUNT = 1000000;

  /**
   * 運用日数を計算
   * @param {string} startDate - 開始日（YYYY-MM-DD）
   * @param {string} endDate - 終了日（YYYY-MM-DD）
   * @returns {number} 運用日数
   */
  static calculateOperationTerm(startDate, endDate) {
    const startTime = new Date(startDate).getTime();
    const endTime = new Date(endDate).getTime();
    const operationTerm = (endTime - startTime) / (86400 * 1000) + 1;

    return isNaN(operationTerm) ? 0 : operationTerm;
  }

  /**
   * 運用期間での利率を計算
   * @param {number} interestRate - 年利
   * @param {number} operationTerm - 運用日数
   * @returns {BigNumber} 運用期間での利率
   */
  static calculateOperationInterestRate(interestRate, operationTerm) {
    let rate;
    try {
      rate = new BigNumber(interestRate).multipliedBy(operationTerm).div(InterestRateCalculator.DAYS_PER_YEAR).dp(7);
    } catch {
      return new BigNumber(0);
    }

    return isNaN(rate) ? new BigNumber(0) : rate;
  }

  /**
   * 配当金額を計算
   * @param {string|number|BigNumber} operationInterestRate - 運用期間での利率
   * @param {string} calculationMethod - 計算方式（'per_unit_based' | 'investment_based'）
   * @param {number} unitPrice - 1口あたりの金額
   * @returns {number} 配当金額
   */
  static calculateDividend(operationInterestRate, calculationMethod, unitPrice) {
    let dividend;
    // 文字列の場合はカンマを除去してから数値化
    const rateValue = typeof operationInterestRate === 'string'
      ? parseFloat(operationInterestRate.replace(/,/g, ''))
      : operationInterestRate;

    if (calculationMethod === 'per_unit_based') {
      // 1口あたりベース: 1口あたりの配当を計算
      dividend = Math.floor(unitPrice * rateValue / 100);
    } else {
      // 投資金額ベース（既存ロジック）
      try {
        const investmentAmount = new BigNumber(InterestRateCalculator.DEFAULT_INVESTMENT_AMOUNT);
        dividend = new BigNumber(rateValue)
          .multipliedBy(investmentAmount)
          .div(100)
          .integerValue(BigNumber.ROUND_FLOOR)
          .toNumber();
      } catch {
        dividend = 0;
      }
    }

    return isNaN(dividend) ? 0 : dividend;
  }
}
